import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Helper from "../../helper";

const OfferBanner = () => {
  const userInfo = Helper();
  const images = [
    "https://images.staticcontent.io/rde/login/bonus-1.webp",
    "https://images.staticcontent.io/rde/login/bonus-4.webp",
    "https://images.staticcontent.io/rde/login/bonus-6.webp",
    "https://images.staticcontent.io/rde/login/bonus-1.webp",
    "https://images.staticcontent.io/rde/login/bonus-4.webp",
    "https://images.staticcontent.io/rde/login/bonus-6.webp",
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,  // Exactly 2 cards on tablet
          slidesToScroll: 1,
          centerMode: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,  // Exactly 2 cards on mobile
          slidesToScroll: 1,
          arrows: false,
          centerMode: false, // Disable center mode to show full cards
          variableWidth: false // Ensure fixed width for 2 cards
        }
      }
    ]
  };

  return (
    <div className={`w-screen mt-[0.26rem] relative left-1/2 right-1/2 -mx-[50vw] overflow-hidden ${userInfo ? 'hidden' : 'block'}`}>
      <Slider {...settings}>
        {images.map((src, index) => (
          <div key={index} className="px-1">
            <div className="rounded-lg overflow-hidden">
              <img
                src={src}
                alt={`offer-${index}`}
                className="w-full h-auto rounded-lg object-cover"
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default OfferBanner;